import styled from '@emotion/styled/macro'
import { mediaQueries } from 'devices'
import mq from 'mediaQuery'

export const H2 = styled('h2')`
  font-size: 18px;
  font-weight: 200;
  color: #adbbcd;

  ${mq.medium`
    font-size: 22px;
  `}
`

export const Title = styled('h2')`
  font-size: 18px;
  font-weight: 100;
  padding: 0;
  margin: 0;
  ${mq.medium`
    font-size: 28px;
  `}
`

export const HR = styled('hr')`
  border: 0;
  border-top: 1px dashed #d3d3d3;
  background-color: #fff;
  margin-bottom: 30px;
  margin-top: 0;
`
export const H1Bold = styled('h1')`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 80px;
  line-height: 88px;
  letter-spacing: -2px;
  margin-bottom: 14px;
  ${mediaQueries.phone} {
    font-size: 50px;
    line-height: 55px;
  }
`

export const H3Bold = styled('h2')`
  font-family: Poppins;
  font-size: 48px;
  line-height: 56px;
  font-weight: 600;
  letter-spacing: -1px;
  margin: 0;
  padding: 0;
  ${mediaQueries.phone} {
    font-size: 30px;
    line-height: 35px;
  }
`

export const H3Medium = styled(H3Bold)`
  font-weight: 400;
`
export const H2Bold = styled('h2')`
  font-family: Roboto;
  font-size: 60px;
  line-height: 120%;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0;
  padding: 0;
  ${mediaQueries.phone} {
    font-size: 40px;
    line-height: 45px;
  }
`

export const Body1Bold = styled('p')`
  font-family: poppins;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.25px;
  font-weight: 700;
  margin: 0;
  padding: 0;
  ${mediaQueries.phone} {
    font-size: 20px;
    line-height: 25px;
  }
`

export const Body1Medium = styled(Body1Bold)`
  font-weight: 500;
`

export const H4Bold = styled('h4')`
  font-size: 34px;
  font-weight: 700;
  font-family: Roboto;
  letter-spacing: 0.25px;
  line-height: 123.5%;
  margin: 0;
  padding: 0;

  ${mediaQueries.phone} {
    font-size: 26px;
    line-height: 30px;
  }
`

export const H6Bold = styled('h6')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin: 0;
  padding: 0;
`

export const SmallText = styled('p')`
  font-family: Poppins;
  font-weight: 700;
  font-size: 17.6px;
  line-height: 20px;
  letter-spacing: 1.89px;
  margin: 0;
  padding: 0;

  ${mediaQueries.phone} {
    font-size: 11px;
    line-height: 15px;
  }
`
export const ListText = styled('p')`
  font-family: Roboto;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.16px;
  margin: 0;
  padding: 0;

  ${mediaQueries.phone} {
    font-size: 14px;
    line-height: 16px;
  }
`

export const Text = styled.div`
  font-style: ${({ fontStyle }) => fontStyle || 'normal'};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ fontWeight }) => fontWeight};
  text-align: ${({ align }) => align};
`
